import type { IconData } from '@stacksjs/iconify-core'

export const irisScan: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M7.152 24.936a3.2 3.2 0 0 1 0-1.872C9.295 16.09 16.027 11 24 11c7.974 0 14.706 5.09 16.849 12.064c.187.61.187 1.262 0 1.872C38.706 31.91 31.974 37 24 37c-7.973 0-14.705-5.09-16.848-12.064\"/><path d=\"M17 24a7 7 0 1 0 14 0a7 7 0 1 0-14 0M13 3s-3.086 0-6.356.193a3.66 3.66 0 0 0-3.45 3.45C3 9.913 3 13 3 13M35 3s3.086 0 6.356.193a3.66 3.66 0 0 1 3.45 3.45C45 9.913 45 13 45 13M35 45s3.086 0 6.356-.193a3.66 3.66 0 0 0 3.45-3.45C45 38.087 45 35 45 35M13 45s-3.086 0-6.356-.193a3.66 3.66 0 0 1-3.45-3.45C3 38.087 3 35 3 35\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default irisScan
